var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('article',{staticClass:"b-contact-list"},_vm._l((_vm.contacts),function(item,index){return _c('ContactItem',_vm._b({key:`contactItem-${index}`,attrs:{"index":index + 1,"minimal":true}},'ContactItem',item,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }